export default "__VITE_ASSET__7df6b51a__"